module.exports = __webpack_public_path__ + "img/VPC-Service.fe61aae.svg";